import { RteRendererSchemeDefinition } from "./rte-renderer-types";
import { BackgroundColor } from "../../background/constants/background-types";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createRteRendererMapDefinition } from "../../../utils/scheme-helper";

export const RTESOURCE_QUILL = "quill";
export const RTESOURCE_AEM = "aem";

export const RTE_SOURCES = [RTESOURCE_QUILL, RTESOURCE_AEM] as const;

function createSchemes() {
  let newSchemes: AllColors.RteRendererSchemeConfiguration<RteRendererSchemeDefinition> = {};

  AllColors.RTE_RENDERER_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      paragraphColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      sublineColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      blockquoteColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      linkColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      linkHoverColor: AllColors[`COLOR_SYSTEM_HIGHLIGHT`],
      linkOutlineColor: AllColors[`COLOR_SYSTEM_HIGHLIGHT`],
      linkHoverOpacity: "1"
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const RTE_RENDERER_SCHEME_CONFIG: AllColors.RteRendererSchemeConfiguration<RteRendererSchemeDefinition> = createSchemes();

export const RTE_RENDERER_SCHEME_MAP: Map<BackgroundColor | "default", RteRendererSchemeDefinition> = new Map(
  Object.entries(createRteRendererMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    RTE_RENDERER_SCHEME_CONFIG[config as string]
  ])
);
